 <!-- Modal For add_sheet_Categ -->
 <div [id]="mdlId" class="modal  custom-modal fade" data-backdrop="static"  role="dialog">
    <div class="modal-dialog   modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="zero_country_form_title">Add Issue </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <form [formGroup]="issueTypeForm" (ngSubmit)="onSubmitIssue()">
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-6">
                           <div class="form-group">
                              <label for="">Select Application<span class="text-danger">*</span></label>
                              <select class="form-control" formControlName="app_id">
                                <option value="">Select</option>
                                <option *ngFor="let data of appDropDown" value={{data.value}}>{{data.label}}</option>
                              </select>
                              <div *ngIf="submit && issueErrorMsg.app_id.errors" class="form-error">
                                <div *ngIf="issueErrorMsg.app_id.errors.required">Application Name is required !</div>
                             </div>
                           </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="">Priority<span class="text-danger">*</span></label>
                                <select
                                id="inputState"
                                class="form-control2"
                                formControlName="priority"
                                >
                                    <option value="0">Low</option>
                                    <option value="1">Medium</option>
                                    <option value="2">High</option>
                                </select>
                                <div *ngIf="submit && issueErrorMsg.priority.errors" class="form-error">
                                    <div *ngIf="issueErrorMsg.priority.errors.required">Priority is required !</div>
                                 </div>
                            </div>
                        </div>
                        <!-- <div class="col-md-6">
                            <div class="form-group">
                               <label for="">Issue Request Date<span class="text-danger">*</span></label>
                               <input type="date" class="form-control" formControlName="issue_req_date"> 
                               <div *ngIf="submit && issueErrorMsg.issue_req_date.errors" class="form-error">
                                <div *ngIf="issueErrorMsg.issue_req_date.errors.required">Issue Request Date is required !</div>
                             </div>
                            </div>
                         </div> -->
                     </div>
                     <div class="row">
                        <div class="col-md-6" *ngIf="mdlId == 'issue_tracker'">
                           <div class="form-group">
                              <label for="cat_desc">Developed By<span class="text-danger">*</span></label>
                              <input class="form-control" id="cat_desc" formControlName="develop_by" type="text" placeholder="Developer Name">
                              <div *ngIf="submit && issueErrorMsg.develop_by.errors" class="form-error">
                                <div *ngIf="issueErrorMsg.develop_by.errors.required">Develop By is required !</div>
                             </div>
                           </div>
                        </div>
                        <div  [ngClass]="mdlId == 'issue_tracker' ? 'col-md-6':'col-md-12'">
                            <div class="form-group">
                               <label for="cat_desc">Issue Description<span class="text-danger">*</span></label>
                               <textarea class="form-control" id="cat_desc"  type="text" formControlName="issue_desc" placeholder="Issue Description"></textarea>
                               <div *ngIf="submit && issueErrorMsg.issue_desc.errors" class="form-error">
                                <div *ngIf="issueErrorMsg.issue_desc.errors.required">Issue Description is required !</div>
                             </div>
                            </div>
                         </div>
                     </div>
                    <div class="row">
                        <div class="col-md-6" *ngIf="mdlId == 'issue_tracker'">
                            <div class="form-group">
                               <label for="cat_desc">Development Date<span class="text-danger">*</span></label>
                               <input class="form-control" id="cat_desc"  type="date" formControlName="devlop_date">
                               <div *ngIf="submit && issueErrorMsg.devlop_date.errors" class="form-error">
                                <div *ngIf="issueErrorMsg.devlop_date.errors.required">Development Date is required !</div>
                             </div>
                            </div>
                        </div>
                        <!-- <div [ngClass]="mdlId == 'issue_tracker' ? 'col-md-6':'col-md-12'">
                           <div class="form-group">
                              <label for="cat_desc">Issue Owner<span class="text-danger">*</span></label>
                              <input class="form-control" id="cat_desc"  type="text" formControlName="issue_owner">
                              <div *ngIf="submit && issueErrorMsg.issue_owner.errors" class="form-error">
                               <div *ngIf="issueErrorMsg.issue_owner.errors.required">Issue Owner is required !</div>
                            </div>
                           </div>
                        </div> -->
                    </div>
                    <div class="row">
                        <div class="col-md-6" *ngIf="mdlId == 'issue_tracker'">
                            <div class="form-group">
                                <label for="cat_desc">Status<span class="text-danger">*</span></label>
                                <select class="form-control" id="" formControlName="status">
                                    <option value="">Select</option>
                                    <option value="1">In Progress</option>
                                    <option value="2">Completed</option>
                                </select>
                                <div *ngIf="submit && issueErrorMsg.status.errors" class="form-error">
                                    <div *ngIf="issueErrorMsg.status.errors.required">Status is required !</div>
                                </div>
                            </div>
                        </div>
                        <div [ngClass]="mdlId == 'issue_tracker' ? 'col-md-6':'col-md-12'" *ngIf="!isEdit">
                            <div class="form-group">
                                <label for="screenshot">Screenshot<span class="text-danger">*</span></label>
                                <input type="file" class="form-control" id="screenshot" formControlName="doc" (change)="onFileChange($event)">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary btn-sm "><i class="fa fa-save"></i> {{isEdit ? 'Update':'Save'}}</button>
                    <button type="button" class="btn btn-danger btn-sm"  data-dismiss="modal"  (click)="closeModal()">Close</button>
                    <button type="submit" class="btn btn-secondary btn-sm" (click)="viewHistory()"><i class="fa fa-save"></i> View History</button>
                </div>
            </form>
        </div>
     </div>
  </div>